export const getScaleInfo = ({ technicalStop, samePlane, sameAirport }) => {
  if (technicalStop && samePlane && sameAirport) {
    return { text: 'Mismo Avión - Escala técnica' };
  }
  if (!technicalStop && samePlane && sameAirport) {
    return { text: 'Mismo avión - Mismo Aeropuerto' };
  }
  if (!technicalStop && !samePlane && sameAirport) {
    return { text: 'Cambio de avión - Mismo Aeropuerto' };
  }
  if (!technicalStop && !samePlane && !sameAirport) {
    return { text: 'Cambio de avión - Cambio de Aeropuerto' };
  }

  return { text: 'Combinación no válida' };
};
